<template>
    <component
        :is="comingFrom === 'cafeteria' ? 'div' : 'router-link'"
        class="relative h-full p-6 shadow-md rounded-lg border border-gray-200 hover:shadow-lg cursor-pointer bg-white"
        :to="
            comingFrom !== 'cafeteria'
                ? {
                      name:
                          comingFrom == 'B2B'
                              ? 'pro-catalog-bikes-details'
                              : 'catalog-bikes-details',
                      params: {
                          id: bike.id,
                          utilisation: bike.utilisation,
                      },
                  }
                : undefined
        "
    >
        <!-- Badge de réduction -->
        <div class="flex">
            <div class="text-center w-full">
                <span v-if="bike.countTotal > 0" class="font-bold text-green">{{
                    $translate('public.shop.home.bikes.card.stock.in-stock')
                }}</span>
                <span
                    v-else-if="
                        bike.countTotal == 0 && bike.availabilityTotal > 0
                    "
                    class="font-bold text-orange-500"
                >
                    {{
                        $translate(
                            'public.shop.home.bikes.card.stock.soon-available',
                        )
                    }}
                </span>
                <span v-else class="font-bold text-red">
                    {{
                        $translate(
                            'public.shop.home.bikes.card.stock.not-in-stock',
                        )
                    }}
                </span>
            </div>
            <span
                v-if="bike.most_ordered"
                class="absolute top-2 left-2 text-red font-bold text-2xl"
            >
                <i class="fa-solid fa-fire"></i>
            </span>

            <div
                v-if="bike.promotion > 0"
                class="absolute top-2 right-2 bg-green text-white font-bold text-lg rounded-full shadow-md p-2.5"
            >
                -{{ Math.round(bike.promotion) }}%
            </div>
        </div>
        <div
            class="relative overflow-hidden flex justify-center items-center aspect-[1.777]"
        >
            <img
                :src="
                    $apiUrl() +
                    '/storage/assets/images/bikes_pictures/' +
                    bike.id +
                    '/A.jpg'
                "
                alt="Bike image"
                class="relative max-w-full grow remove_bg_color"
                @error="
                    e => {
                        e.target.src = defaultImage; // Use the preloaded default image
                        e.target.onerror = null; // Prevent infinite loop
                    }
                "
            />
        </div>
        <h3 class="text-2xl font-black pt-4 text-gray-800 text-center">
            {{ bike.brand }} {{ bike.model }}
        </h3>
        <div class="py-2 box-border grid grid-cols-3 gap-3 text-gray-600">
            <div
                v-if="bike.electric == 'Y'"
                class="flex flex-col items-center text-center"
            >
                <i class="fas fa-cogs text-xl mb-1"></i>
                <span class="text-xs">{{ bike.motor }}</span>
            </div>
            <div
                v-if="bike.electric == 'Y'"
                class="flex flex-col items-center text-center"
            >
                <i class="fas fa-battery-full text-xl mb-1"></i>
                <span class="text-xs">{{ bike.battery?.slice(0, 25) }}</span>
            </div>
            <div
                class="flex flex-col items-center text-center"
                v-if="bike.electric == 'N' && bike.transmission"
            >
                <i class="fas fa-link text-xl mb-1"></i>
                <span class="text-xs">{{ bike.transmission }}</span>
            </div>
            <div
                class="flex flex-col items-center text-center"
                v-if="bike.electric == 'N' && bike.weight"
            >
                <i class="fa-solid fa-weight-scale text-xl mb-1"></i>
                <span class="text-xs">{{ bike.weight }} kgs</span>
            </div>

            <div
                class="flex flex-col items-center text-center"
                v-if="bike.electric == 'N' && bike.brakes && !bike.weight"
            >
                <i class="fas fa-circle-stop text-xl mb-1"></i>
                <span class="text-xs">{{ bike.brakes.slice(0, 25) }}</span>
            </div>
            <div class="flex flex-col items-center text-center">
                <strong>Tailles</strong><br />
                <div class="text-xs">
                    <template v-for="(size, index) in bike.sizes" :key="size">
                        <span
                            :class="{
                                'text-green font-bold': bike.stocks[size],
                                'text-orange-500 font-bold':
                                    bike.availability[size] &&
                                    !bike.stocks[size],
                                'text-red font-bold':
                                    !bike.stocks[size] &&
                                    !bike.availability[size],
                            }"
                        >
                            {{ size }} </span
                        ><span v-if="index < bike.sizes.length - 1"> / </span>
                    </template>
                </div>
            </div>
        </div>
        <div class="grid text-gray-600 gap-4 grid-cols-2 text-center mt-4">
            <span class="font-black text-green">
                {{
                    $translate('public.shop.home.bikes.card.payements.purchase')
                }}
                :<br />
                <del v-if="bike.promotion > 0" class="text-red">
                    {{ formatPrice(round(bike.price_htva * 1.21)) }}
                    <br />
                </del>
                {{
                    formatPrice(
                        round(bike.price_htva * 1.21) -
                            round(
                                (bike.price_htva * bike.promotion * 1.21) / 100,
                            ),
                    )
                }}
            </span>
            <br />
            <span class="font-black text-grey-800">
                {{
                    $translate('public.shop.home.bikes.card.payements.leasing')
                }}
                : <br />
                <del
                    v-if="bike.leasing_price_full?.tvac?.leasingPrice"
                    class="text-red"
                >
                    {{
                        formatPrice(
                            round(bike.leasing_price_full?.tvac?.leasingPrice),
                        )
                    }}/{{
                        $translate(
                            'public.shop.home.bikes.card.payements.month',
                        )
                    }}
                    <br />
                </del>

                {{ formatPrice(bike.leasing_price?.tvac?.leasingPrice) }}/{{
                    $translate('public.shop.home.bikes.card.payements.month')
                }}
            </span>
        </div>
        <div v-if="comingFrom == 'B2B'">
            <div class="h-20"></div>
            <div
                class="w-full text-center text-black absolute bottom-0 left-0 p-4"
            >
                Impact sur salaire net : <br />
                <strong
                    >{{
                        formatPrice(
                            bike.leasing_price?.tvac?.leasingPrice * 0.39245,
                        )
                    }}/{{
                        $translate(
                            'public.shop.home.bikes.card.payements.month',
                        )
                    }}</strong
                >
            </div>
        </div>
        <div v-else-if="comingFrom == 'cafeteria'">
            <div class="h-20"></div>
            <div
                class="w-full text-center text-black absolute bottom-0 left-0 p-4"
            >
                <primary-button
                    @click="
                        (offerModalIsOpen = true),
                            (bikeSelected = bike),
                            (selectedSize = bike.sizes[0])
                    "
                >
                    {{
                        $translate(
                            'public.shop.home.bikes.card.details.offer.title',
                        )
                    }}
                </primary-button>
            </div>
        </div>
    </component>
    <modal
        :open="offerModalIsOpen"
        @close="
            () => {
                offerModalIsOpen = false;
            }
        "
    >
        <template #title> Demander une offre pour le vélo </template>
        <template #content>
            <div
                class="w-full md:w-3/4 mx-auto mt-4 grid grid-cols-1 md:grid-cols-2"
                v-if="bikeSelected"
            >
                <div>
                    <div
                        class="left-flex"
                        :class="bike.electric !== 'Y' ? 'mt-4' : ''"
                    >
                        <div class="aspect-[1.777] w-full">
                            <img
                                class="img remove_bg_color"
                                :src="
                                    !bike.is_selling
                                        ? $storageUrl(
                                              '/assets/images/bikes_pictures/' +
                                                  bike.id +
                                                  '/A.jpg',
                                          )
                                        : $storageUrl(
                                              +'/assets/images/bikes_pictures/occasion/' +
                                                  bike.bikes_id +
                                                  '.jpg',
                                          )
                                "
                                :alt="bike.brand + ' ' + bike.model"
                                @error="
                                    e =>
                                        (e.target.src =
                                            '/storage/assets/images/default.png')
                                "
                            />
                        </div>
                        <div
                            class="flex justify-center"
                            v-if="bike.electric == 'Y'"
                        >
                            <div>
                                <div class="text-xl text-red font-bold">
                                    {{
                                        $translate(
                                            'public.shop.home.bikes.card.details.speed',
                                        )
                                    }}
                                </div>
                                <div class="stat">
                                    {{
                                        bike.utilisation == 'Speed Pedelec'
                                            ? '45 km/h'
                                            : '25 km/h'
                                    }}
                                </div>
                            </div>
                            <div class="w-1 bg-red m-2 h-12"></div>
                            <div>
                                <div class="text-xl text-red font-bold">
                                    {{
                                        $translate(
                                            'public.shop.home.bikes.card.details.autonomy',
                                        )
                                    }}
                                </div>
                                <div class="stat">{{ bike?.autonomy }} km</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="justify-center text-center">
                        <div class="flex text-center justify-center">
                            <strong class="text-xl font-bold text-red">
                                {{ bike.brand + ' ' + bike.model }}
                            </strong>
                        </div>
                        <div class="align-items-end w-100 gap-2 mb-2">
                            <div
                                v-if="bike.promotion != 0"
                                class="promo-container"
                            >
                                <del class="del-price">
                                    {{ formatPrice(bike?.price_tvac) }}
                                </del>
                                <div class="text-xl font-bold text-black">
                                    {{
                                        formatPrice(
                                            bike?.price_tvac -
                                                (bike?.price_tvac *
                                                    bike.promotion) /
                                                    100,
                                        )
                                    }}
                                </div>
                            </div>
                            <p class="text-xl font-bold text-black" v-else>
                                {{ bike?.price_tvac }} €
                            </p>
                        </div>
                        <div v-if="bike.promotion" class="w-full text-red">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            <strong class="ml-4">{{
                                $translate(
                                    'public.shop.home.bikes.card.details.promotion.explanation',
                                )
                            }}</strong>
                        </div>

                        <div class="description mt-4 text-left">
                            <h2 class="font-bold text-xl mb-2">
                                {{
                                    $translate(
                                        'public.shop.home.bikes.card.details.description.description-title',
                                    )
                                }}
                            </h2>
                            <p
                                class="text"
                                v-if="bike?.description"
                                v-html="bike?.description"
                            ></p>
                            <p class="text" v-if="!bike?.description">
                                {{
                                    $translate(
                                        'public.shop.home.bikes.card.details.description.description-empty',
                                    )
                                }}
                            </p>
                        </div>

                        <div class="mt-4">
                            <Sizes
                                type="bike_cafeteria"
                                :item="bikeSelected"
                                :selectedSize="selectedSize"
                                @updateSize="selectedSize = $event"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { useMixinMethods } from '@/js/composable/useMixinMethods';
import formatPrice from '@/js/functions/formatPrice';
import round from '@/js/functions/round';
import Sizes from '@/js/views/public/shop/accessories/partials/Sizes.vue';
import { ref } from 'vue';
const { $storageUrl } = useMixinMethods();
const offerModalIsOpen = ref(false);
const selectedSize = ref(null);

defineProps({
    bike: Object,
    comingFrom: String,
});
const defaultImage = $storageUrl('/assets/images/default.png');
const bikeSelected = ref({});

const preloadDefaultImage = () => {
    const img = new Image();
    img.src = defaultImage;
};
preloadDefaultImage();
</script>

<style scoped lang="scss">
@use '@/scss/variables' as vars;
</style>
